import React, { FC } from 'react';
import { ImageItem, GalleryImages } from '@/ui/components';

import { ReplaceImageType } from '@/utils/constants';
import { InspectionPageTab } from '../types';
import { useAppCustomers } from '@/hooks';

export const Images: FC<InspectionPageTab> = ({ inspection }) => {
  const { hasSuperAdminAccess } = useAppCustomers();
  const {
    frontImageFileUrl,
    rearImageFileUrl,
    nearsideImageFileUrl,
    offsideImageFileUrl,
    chargeLevelImageFileUrl,
    chargeCablesImageFileUrl,
    keysImageFileUrl,
    istaCheckListImageUrl,
    frontResizedImageUrl,
    rearResizedImageUrl,
    nearsideResizedImageUrl,
    offsideResizedImageUrl,
    chargeLevelResizedImageUrl,
    chargeCablesResizedImageFileUrl,
    keysImageResizedFileUrl,
    istaCheckListResizedImageUrl,
  } = inspection;

  const images: ImageItem[] = [
    {
      id: 1,
      imageFileUrl: frontImageFileUrl,
      thumbnailImageUrl: frontResizedImageUrl,
      key: 'frontImageFileUrl',
      replaceImage: { id: inspection.id, type: ReplaceImageType.ImagesFront },
    },
    {
      id: 2,
      imageFileUrl: rearImageFileUrl,
      thumbnailImageUrl: rearResizedImageUrl,
      key: 'rearImageFileUrl',
      replaceImage: { id: inspection.id, type: ReplaceImageType.ImagesRear },
    },
    {
      id: 3,
      imageFileUrl: nearsideImageFileUrl,
      thumbnailImageUrl: nearsideResizedImageUrl,
      key: 'nearsideImageFileUrl',
      replaceImage: {
        id: inspection.id,
        type: ReplaceImageType.ImagesNearside,
      },
    },
    {
      id: 4,
      imageFileUrl: offsideImageFileUrl,
      thumbnailImageUrl: offsideResizedImageUrl,
      key: 'offsideImageFileUrl',
      replaceImage: { id: inspection.id, type: ReplaceImageType.ImagesOffside },
    },
    {
      id: 5,
      imageFileUrl: chargeLevelImageFileUrl,
      thumbnailImageUrl: chargeLevelResizedImageUrl,
      key: 'chargeLevelImageFileUrl',
      replaceImage: {
        id: inspection.id,
        type: ReplaceImageType.ImagesChargeLevel,
      },
    },
    {
      id: 6,
      imageFileUrl: chargeCablesImageFileUrl,
      thumbnailImageUrl: chargeCablesResizedImageFileUrl,
      key: 'chargeCablesImageFileUrl',
      replaceImage: {
        id: inspection.id,
        type: ReplaceImageType.ImagesChargeCables,
      },
    },
    {
      id: 5,
      imageFileUrl: keysImageFileUrl,
      thumbnailImageUrl: keysImageResizedFileUrl,
      key: 'keysImageFileUrl',
      replaceImage: { id: inspection.id, type: ReplaceImageType.ImagesKeys },
    },
    {
      id: 6,
      imageFileUrl: istaCheckListImageUrl,
      thumbnailImageUrl: istaCheckListResizedImageUrl,
      key: 'ISTAImageFileUrl',
      replaceImage: {
        id: inspection.id,
        type: ReplaceImageType.ImagesIstaCheckList,
      },
      description: 'ISTA',
    },
  ];

  return (
    <div className="d-flex justify-content-center">
      <GalleryImages
        images={images}
        actions={{
          replaceImage: hasSuperAdminAccess ? () => {} : undefined,
        }}
        showCaption
        autoplay
        className="mw-50"
      />
    </div>
  );
};
